import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {PitErrorPageComponent} from "./pit-common/ui/components/pit-error-page/pit-error-page.component";
import {PitLoginPageComponent} from "./pit-common/ui/components/pit-login-page/pit-login-page.component";
import {PitWelcomePageComponent} from "./pit-common/ui/components/pit-welcome-page/pit-welcome-page.component";
import {PitDashboardFilesComponent} from "./pit-common/ui/components/pit-dashboard-files/pit-dashboard-files.component";


const routes: Routes = [
  {path: '', redirectTo: 'navigator', pathMatch: 'full'},
  {path: 'login', component: PitLoginPageComponent},
  {path: 'welcome', component: PitWelcomePageComponent},
  {path: 'files', component: PitDashboardFilesComponent},
  {path: 'error', component: PitErrorPageComponent}
];


@NgModule({
  imports: [RouterModule.forRoot(routes, {
    enableTracing: false,
    onSameUrlNavigation: "reload",
    relativeLinkResolution: "corrected"
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
